module.exports = __webpack_public_path__ + "media/images/features/3/spacemarket-logo-5d5fcad5a9bc5f85a428a590fc22b6bc.png";